@if (visible && user) {
  <div class="card mt-4 shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title">Two-factor authentication</h3>
      @if (!settingUp && user.mfaEnabled) {
        <span class="badge bg-success"><i class="bi bi-shield-check me-1"></i>Active</span>
      }
    </div>
    <div class="card-body">
      @if (isOwnProfile && !settingUp && !user.mfaEnabled) {
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">Two-factor authentication is not active for your account.</p>
          <button type="button" class="btn btn-primary" [disabled]="submitting" (click)="startSetup()">Activate 2FA</button>
        </div>
      }

      @if (!isOwnProfile && !user.mfaEnabled) {
        <p class="text-muted mb-0">Two-factor authentication is not active for this user.</p>
      }

      @if (settingUp) {
        <div class="row">
          <div class="col-md-4 text-center">
            @if (qrCodeSrc) {
              <img [src]="qrCodeSrc" alt="2FA QR code" class="two-factor-qr" />
            }
          </div>
          <div class="col-md-8">
            <p>Scan the QR code with Google Authenticator, Microsoft Authenticator or a similar app, then enter the 6-digit code to confirm.</p>
            @if (secret) {
              <p class="small text-muted">Or enter this key manually: <code>{{ secret }}</code></p>
            }

            <div class="mb-3 col-4">
              <label class="form-label" for="two-factor-code">Confirmation code</label>
              <input
                id="two-factor-code"
                type="text"
                inputmode="numeric"
                maxlength="6"
                class="form-control"
                [class.is-invalid]="error"
                [disabled]="submitting"
                [(ngModel)]="code"
                placeholder="000000" />
              @if (error) {
                <div class="invalid-feedback d-block">{{ error }}</div>
              }
            </div>

            <div class="d-flex gap-2">
              <button type="button" class="btn btn-success" [disabled]="submitting" (click)="confirmSetup()">Confirm</button>
              <button type="button" class="btn btn-secondary" [disabled]="submitting" (click)="cancelSetup()">Cancel</button>
            </div>
          </div>
        </div>
      }

      @if (!settingUp && !disabling && user.mfaEnabled) {
        <div class="d-flex justify-content-between align-items-center">
          <p class="mb-0">
            @if (isOwnProfile) {
              Two-factor authentication is currently protecting this account's login.
            } @else {
              Two-factor authentication is active for this user.
            }
          </p>
          <button type="button" class="btn btn-outline-danger" (click)="requestDisable()">
            {{ isOwnProfile ? 'Disable 2FA' : 'Remove MFA' }}
          </button>
        </div>
      }

      @if (disabling) {
        <div>
          <p>To disable two-factor authentication, enter the current code from your authenticator app.</p>

          <div class="mb-3 col-4">
            <label class="form-label" for="two-factor-disable-code">Confirmation code</label>
            <input
              id="two-factor-disable-code"
              type="text"
              inputmode="numeric"
              maxlength="6"
              class="form-control"
              [class.is-invalid]="disableError"
              [disabled]="submitting"
              [(ngModel)]="disableCode"
              placeholder="000000" />
            @if (disableError) {
              <div class="invalid-feedback d-block">{{ disableError }}</div>
            }
          </div>

          <div class="d-flex gap-2">
            <button type="button" class="btn btn-danger" [disabled]="submitting" (click)="confirmDisable()">Confirm disable</button>
            <button type="button" class="btn btn-secondary" [disabled]="submitting" (click)="cancelDisable()">Cancel</button>
          </div>
        </div>
      }
    </div>
  </div>
}
